import gql from 'graphql-tag';

export const UPLOAD_IMAGES = gql`
  mutation UploadImages($articleGroupId: Int!, $files: [Upload!]!) {
    uploadImages(articleGroupId: $articleGroupId, files: $files) {
      errors
      creativeImages {
        id
        url
        imageType
        metrics {
          ctr
          spent
        }
      }
    }
  }
`;
